export default {
  assignType: 'Assign type',
  fileAttachments: 'File attachments',
  plural: 'Attachments',
  pluralGenitive: 'Attachments',
  pluralLowerCase: 'attachments',
  drawing: 'Drawing',
  drawings: 'Drawings',
  download: 'Download',
  gridView: 'Grid view',
  file: 'File attachment',
  ld: 'LD',
  listView: 'List view',
  references: 'References',
  reference: 'Reference',
  seeAll: 'See all attachments',
  seeAllNAttachments: {
    seeAll: 'See all',
    attachments: 'attachments'
  },
  textures: 'Textures',
  texture: 'Texture',
  threeD: '3D'
};
